import component from './applicant_reset_dialog.vue'
export default component
